import React, { useContext, useEffect, useState } from 'react';
import { AuthContext } from './../AuthContext';
import { Link } from "react-router-dom";
import api from './../api.js';
import { site_url, invoice_img } from "./../config.js";
import { IndianCurrencyFormatter, FormatDate } from './../Function';

function Monthlist() {

    const { user, refreshUser, vendordetails, fulluser } = useContext(AuthContext);
    const [Transaction, setTransaction] = useState([]);


    useEffect(() => {
        if (user) {
            transaction();
        }
    }, [user]);


    const transaction = async () => {
        try {
            const data = {
                "id": user || fulluser?.id
            }
            const response = await api.post('/vendor/monthtranstions', data);
            if (response.data) {
                setTransaction(response.data.transtions);
            }
            // Axios auto-parses JSON
        } catch (error) {
            console.error('Failed to fetch transactions:', error);
            // Don't throw error to prevent app crash. Auth interceptor handles redirects.
        }
    };


    return (
        <div>

            {Transaction.map((item) => (


                <Link to={`/Payment?id=${item.id}`} className="item">

                    <div className="detail">
                        <img
                            src={invoice_img}
                            alt="img"
                            className="image-block imaged w48"
                        />
                        <div>
                            <strong>#{item.billno}</strong>
                            <div style={{ fontSize: '0.9em', color: '#666', marginTop: '2px' }}>
                                Token: <span style={{ color: '#007bff', fontWeight: 'bold' }}>{item.token_no}</span>
                            </div>
                            <div style={{ fontSize: '0.8em', color: '#666', marginTop: '2px' }}>
                                {item.date_time}
                            </div>
                            {item.paytype === 'cash' && (
                                <div style={{ fontSize: '0.8em', marginTop: '4px' }}>
                                    {item.is_paid == '0' ? (
                                        <span className="badge badge-success" style={{ fontSize: '0.7em' }}>
                                            Paid (Cash)
                                        </span>
                                    ) : (
                                        <span className="badge badge-danger" style={{ fontSize: '0.7em' }}>
                                            Unpaid (Cash)
                                        </span>
                                    )}
                                    {item.commission_paid === 1 ? (
                                        <div></div>
                                    ) : (
                                        <div></div>
                                    )}
                                </div>
                            )}
                            {item.paytype === 'online' && (
                                <div style={{ marginTop: '4px' }}>
                                    {item.is_paid == '0' ? (
                                        <span className="badge badge-success" style={{ fontSize: '0.7em' }}>Paid (Online)</span>
                                    ) : (
                                        <span className="badge badge-warning" style={{ fontSize: '0.7em' }}>Pending (Online)</span>
                                    )}
                                </div>
                            )}
                            {item.is_paid == '2' && (
                                <div style={{ marginTop: '4px' }}>
                                    <span className="badge badge-warning" style={{ fontSize: '0.7em' }}>Cancelled</span>
                                </div>
                            )}

                        </div>
                    </div>
                    <div className="right">
                        <div className="price text-danger"><IndianCurrencyFormatter amount={(parseFloat(item.billamount) + parseFloat(item.tax))} /></div>
                        {/* {item.customer_reward_used > 0 && (
                            <div className="text-success" style={{ fontSize: '0.8em', fontWeight: 'bold' }}>
                                Reward Used : <IndianCurrencyFormatter
                                    amount={(() => {
                                        const reward = parseFloat(item.customer_reward_used);
                                        const dbComm = parseFloat(item.admin_commission_amount);
                                        const comm = (dbComm > 0) ? dbComm : ((parseFloat(item.billamount) + parseFloat(item.tax)) * parseFloat(item.admincommisition) / 100);
                                        return Math.max(0, reward - comm);
                                    })()}
                                />
                            </div>
                        )} */}
                    </div>
                </Link>

            ))}

        </div>
    )
}

export default Monthlist